import React, { useEffect, useState } from "react";
import { corefetch,ImageURL } from "../../../Util/axios_core_helper";

const RentalGuidelinesDetails = () => {
  const [subDatas, setSubDatas] = useState([]);
  const [BreadcrumList, setBreadcrumList] = useState([]);

  const fetchSubData = async () => {
    try {
      const response = await corefetch(
        "RentalGuidlines/GetRentalGuidlinesSubPage"
      );
      if (response && response.length > 0) {
        setSubDatas(response);
      } else {
        console.log("No rental highlights details found");
      }
    } catch (error) {
      console.error("Error fetching rental highlights details:", error);
    }
  };
  const [activeItem, setActiveItem] = useState(null);

   const fetchBreadcrumImageData = async () => {
        try {
          const response = await corefetch(
            "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=RGUIDE"
          );
          if (response && response.length > 0) {
            console.log("fxftyxfyt:", response);
            setBreadcrumList(response);
          } else {
            setBreadcrumList([]);
            console.log("No Breadcrum found");
          }
        } catch (error) {
          console.error("Error fetching Breadcrum List:", error);
          setBreadcrumList([]);
        }
      };
      
     
  useEffect(() => {
    fetchSubData();
    fetchBreadcrumImageData();
  }, []);

  const backgroundImageStyle = BreadcrumList[0]
            ? {
                backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }
            : {};
  useEffect(() => {
    const $ = window.jQuery;

    // Navbar and logo update logic
    const navbar = $(".navbar");
    const logo = $(".navbar .logo> img");
    const paymentIcon = $(".payment");
    const cartIcon = $(".cart");
    navbar.addClass("shared-banner-style");
    logo.attr("src", "/assets/images/corporate-img/img/logo/meridian.png");
    if (navbar.hasClass("shared-banner-style")) {
      $(".navbar .navbar-nav .nav-link").css("color", "#000");
      $(".dropdown .nav-link i").css("color", "black");
      $(".payment ,.cart")
        .css({
          color: "black",
          display: "block",
          visibility: "visible",
          opacity: 1,
          position: "relative",
          zIndex: 9999,
          top: "10px",
        })
        .addClass("force-black");
    }

    $(".accordion-link").on("click", function () {
      const $parentItem = $(this).parent();
      const itemId = $parentItem.data("id"); // Get item ID

      if ($parentItem.hasClass("active")) {
        // If the item is already active, close it
        $parentItem.removeClass("active");
        $parentItem.find(".answer").css("max-height", "0");
        $parentItem.find(".fa-angle-down").removeClass("rotate"); // Remove rotate class
        setActiveItem(null); // Reset active item
      } else {
        // If the item is not active, open it
        $parentItem.addClass("active");
        $parentItem
          .find(".answer")
          .css(
            "max-height",
            $parentItem.find(".answer").prop("scrollHeight") + "px"
          );
        $parentItem.find(".fa-angle-down").addClass("rotate"); // Add rotate class to the active arrow
        setActiveItem(itemId); // Set active item
      }
    });

    return () => {
      $(".accordion-link").off("click");
    };
  }, [subDatas]);

  return (
    <>
      <div className="wpo-page-title " style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div
                className="wpo-breadcumb-wrap"
                style={{ textAlign: "center" }}
              >
                <h2 style={{ color: "white" }}>Rental Guidelines</h2>
                <ol
                  className="wpo-breadcumb-wrap"
                  style={{
                    color: "white",
                    display: "inline-block",
                    padding: 0,
                  }}
                >
                  <li>
                    <a
                      href="/home"
                      style={{
                        cursor: "pointer",
                        color: "white",
                        textDecoration: "none", // Removes underline
                      }}
                    >
                      Home
                    </a>
                  </li>

                  <span style={{ color: "white", margin: "0 5px" }}>|</span>
                  <li
                    style={{
                      color: "white",
                    }}
                  >
                    Rental Guidelines
                  </li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </div>
      <section>
        <div className="containerarr shared-banner-style">
          {subDatas.length > 0 && (
            <div className="accordion">
              {subDatas.map((item) => (
                <div
                  className="accordion-itemx"
                  data-id={item.rentalGuidlinesID}
                  key={item.rentalGuidlinesID}
                >
                  <input
                    type="checkbox"
                    id={`item-${item.rentalGuidlinesID}`}
                    className="accordion-toggle"
                  />
                  <label
                    className="accordion-link"
                    htmlFor={`item-${item.rentalGuidlinesID}`}
                  >
                    <div className="flex">
                      <h3>{item.title}</h3>
                      <i
                        className={`fa fa-angle-down ${
                          item.rentalGuidlinesID === activeItem ? "rotate" : ""
                        }`}
                      ></i>
                    </div>
                  </label>
                  <div className="answer">
                    <p>{item.description}</p>
                  </div>
                  <hr />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default RentalGuidelinesDetails;
